// extracted by mini-css-extract-plugin
export var menuIcon = "_oq-0";
export var menuIconInline = "_oq-1";